import styled from 'styled-components';
import { Provider } from 'react-redux';
import { store } from 'store';
import { ToastrManagerComponent } from 'components/common/toaster/toastr-manager-component';
import { Modal } from 'components/common/modal';
import { muiTheme } from 'constants/mui-theme';
import JoinManger from 'components/join/components/join';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { TranslationProvider } from 'contexts/translation-context';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import 'assets/stylesheets/preapp.scss';
import 'assets/stylesheets/global-styles.scss';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { CAPTCHA_URL } from 'constants/urls';
import GlobalStyle from './global-styles';
import IntercomProvider from 'components/common/intercom-provider';

const stripePromise = loadStripe(CONFIG.STRIPE_API_KEY);

const SiteWrapper = styled.div``;

export const App = () => {
  return (
    <SiteWrapper>
      <GlobalStyle />
      <Provider store={store}>
        <Elements stripe={stripePromise}>
          <TranslationProvider>
            <MuiThemeProvider theme={muiTheme}>
              <IntercomProvider>
                <Modal className="modal-class" />
                <ToastrManagerComponent />
              </IntercomProvider>
              <GoogleReCaptchaProvider reCaptchaKey={CAPTCHA_URL}>
                <JoinManger />
              </GoogleReCaptchaProvider>
            </MuiThemeProvider>
          </TranslationProvider>
        </Elements>
      </Provider>
    </SiteWrapper>
  );
};

export default App;
